<template>
  <v-footer
    id="footer-menu"
    absolute
    :class="{
      'footer-menu-open': isArticleOpen,
      'featured-articles-open': showFeaturedArticles
    }"
  >
    <v-col id="footer-menu-icons" cols="12">
      <span id="icon" @click="selectMenuAction('themes')">
        <div
          id="menu-icon"
          class="icon-image"
          :style="{
            'background-image': 'url(' + `${get5dBackgroundImage}` + ')'
          }"
        >
          <img v-if="hasSelectedTheme" :src="`${getSelectedThemeIcon}`" />

          <BaseIcon
            v-if="hasSelectedTheme"
            multiplatform
            icon="theme-remove"
            size="16px"
            class="remove-theme"
          />
        </div>
      </span>

      <span id="icon" @click="selectMenuAction('routes')">
        <div
          id="menu-icon"
          class="icon-image"
          :style="{
            'background-image': 'url(' + `${getRouteBackgroundImage}` + ')'
          }"
        >
          <img v-if="hasSelectedRoute" :src="`${getSelectedRouteIcon}`" />

          <BaseIcon
            v-if="hasSelectedRoute"
            multiplatform
            icon="route-remove"
            size="16px"
            class="remove-route"
          />
        </div>
      </span>

      <span id="menu-icon" @click="selectMenuAction('search')">
        <BaseIcon multiplatform size="64px" icon="search" />
      </span>

      <span id="menu-icon" @click="selectMenuAction('center')">
        <BaseIcon multiplatform size="64px" icon="position" />
      </span>
    </v-col>
  </v-footer>
</template>

<script>
import { mapState } from "vuex";
import { appIdentifier } from "@/utils/appIdentifier.js";

export default {
  name: "FooterMenu",
  computed: {
    ...mapState({
      theme: state => state.theme,
      route: state => state.route,
      articleDrawer: state => state.articleDrawer,
      openMenuDrawer: state => state.openMenuDrawer,
      showFeaturedArticles: state => state.showFeaturedArticles
    }),
    hasSelectedTheme() {
      return this.theme?.icon;
    },
    hasSelectedRoute() {
      return this.route?.icon;
    },
    getSelectedThemeIcon() {
      if (this.theme?.icon) {
        return `data:image/png;base64, ${this.theme.icon_selected}`;
      }
      return null;
    },
    get5dBackgroundImage() {
      if (this.theme?.icon) {
        return `${require(`@/assets/svg/${this.getAppName()}/icon-selected-theme.svg`)}`;
      }
      return `${require(`@/assets/svg/${this.getAppName()}/icon-5D.svg`)}`;
    },
    getSelectedRouteIcon() {
      if (this.route?.icon) {
        return `data:image/png;base64, ${this.route.icon_selected}`;
      }
      return null;
    },
    getRouteBackgroundImage() {
      if (this.route?.icon) {
        return `${require(`@/assets/svg/${this.getAppName()}/icon-selected-route.svg`)}`;
      }
      return `${require(`@/assets/svg/${this.getAppName()}/icon-route.svg`)}`;
    },
    isArticleOpen() {
      return this.articleDrawer;
    }
  },
  methods: {
    getAppName() {
      return appIdentifier();
    },
    selectMenuAction(action) {
      //Make available only when main menu is closed
      if (!this.openMenuDrawer) {
        if (action == "themes") {
          if (this.theme?.map_pois) {
            //Reset map pois
            this.$store.commit(this.$mutations.RESET_THEME);
          } else {
            this.$store.commit(this.$mutations.TOGGLE_SIDEBAR_MENU, {
              mode: "themes"
            });
          }
        }
        if (action == "routes") {
          if (this.route?.route_pois) {
            //Reset route pois
            this.$store.commit(this.$mutations.RESET_ROUTE);
          } else {
            this.$store.commit(this.$mutations.TOGGLE_SIDEBAR_MENU, {
              mode: "routes"
            });
          }
        }
        if (action == "search") {
          this.$store.commit(this.$mutations.TOGGLE_SIDEBAR_MENU, {
            mode: "search"
          });
        }
        if (action == "center") {
          this.$eventBus.$emit("CENTER_MAP");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-footer {
  align-items: baseline !important;
}

#footer-menu {
  width: 25vw;
  margin: 0 auto;
  height: 100px;
  background-color: transparent;
  z-index: 5;

  &-icons {
    display: flex;
    justify-content: space-evenly;

    &:hover {
      cursor: pointer;
    }

    .icon-image {
      position: relative;
      height: 64px;
      width: 64px;
      background-position: center center;

      img {
        height: 100%;
        width: 100%;
        object-fit: contain;
        padding: 16px 19px 19px 20px;
      }

      div.remove-theme,
      div.remove-route {
        position: absolute !important;
        right: 5px;
        top: 5px;
      }
    }
  }
}

.footer-menu-open {
  margin-left: 25% !important;
}

.featured-articles-open {
  right: 50vw !important;
}
</style>
